import { render, staticRenderFns } from "./FscSimpleCard.vue?vue&type=template&id=76ecdde7&"
import script from "./FscSimpleCard.vue?vue&type=script&lang=ts&"
export * from "./FscSimpleCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports